import getUrl from '../data/conn/get/paths'
export const getFileUrl =
	(typeof window !== 'undefined' && window.location.href.includes('amplifyapp.com')) ||
	process.env.serverType === 'local' ||
	process.env.serverType === 'develop'
		? `${process.env.developUrl}${getUrl.downloadFile}?filePath=`
		: `${process.env.serverUrl}${getUrl.downloadFile}?filePath=`

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export const decimalSeparatedNumber = (number, options = {}) => {
	const _amount = parseFloat(number)

	if (isNaN(_amount)) return options.default ?? '-'

	return _amount.toLocaleString('en-IN', options)
}
export const displayAmount = (amount, options) => {
	return decimalSeparatedNumber(amount, {
		currency: 'INR',
		style: 'currency',
		...options,
	})
}

export const GetPanFromGst = (gstin) => {
	const s = (gstin || '').toUpperCase().replace(/\s+/g, '')
	const m = s.match(/^\d{2}([A-Z]{5}\d{4}[A-Z])[1-9A-Z]Z[0-9A-Z]$/)
	return m ? m[1] : null
}

export const GetImagePath = (imagePath) => {
	return imagePath?.includes('http') ? imagePath : getFileUrl + imagePath
}
